const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/eCheckin/components/fields/PhoneNumberField.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { validatePhoneNumber, ValidationFunction } from '@cistec/common_web/components/Forms/utils/validation';
import { CIS4mPhoneNumberField } from '@cistec/common_web/modules/CIS4m/components/CIS4mPhoneNumberField';
import { TextInput, useText } from '@cistec/common_web/utils/intlUtils';

interface Props {
    label: TextInput;
    path: string;
    countryCodePath?: string;
    checkValidity?: ValidationFunction;
    hidden?: boolean;
    required?: boolean;
}

export const PhoneNumberField = forwardRef((props: Props, ref: any) => {
    const phoneNumberFieldRef = useCIS4m(ref);

    const hidden = props.hidden ?? false;
    const required = props.required ?? false;
    const label = useText(props.label);

    const checkValidity = props.checkValidity ?? validatePhoneNumber;

    return (
        <CIS4mPhoneNumberField
            ref={phoneNumberFieldRef}
            label={label}
            path={props.path}
            countryCodePath={props.countryCodePath}
            checkValidity={checkValidity}
            hidden={hidden}
            required={required}
        />
    );
});

PhoneNumberField.displayName = 'PhoneNumberField';
